import React from "react";

export const selectOpts = [...Array(21).keys()].map((_, idx) => ({
  key: idx,
  value: String(idx),
  label: `鏈結數 >= ${idx}`,
}));
